import gql from 'graphql-tag';

export const iridiumEvents = gql`
query getIridiumEvents{
  getIridiumEvents {
    _id
    dateCreated
    findDispositivoByImei {
      uuid
      nombre
    }
    msg {
      ieid
      nombielongi
      cdr
      imei
      momsn
      mtmsn
      timestamp
      payload {
        valores {
          tag
          valor
          findTipoDatoByTag {
            uuid
            nombre
            unidad
          }
        }
        alarmas {
          tipo
          lluvia
          altlm
        }
      }
    }
  }
}`


